import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { SettingsPage } from '../../settings/settings-page.js';

/** `/settings` (1.V-2 deliverable 9): guarded like every other authenticated route. */
export const Route = createFileRoute('/settings/')({
  staticData: { crumb: 'Settings' },
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: SettingsPage,
});
